<div class="app-sidebar-skeleton">
  <ul class="list">
    <li *ngFor="let _ of [0, 1, 2, 3, 4, 5, 6]">
      <p-skeleton width="100%" height="2rem" styleClass="mb-3" />
    </li>
  </ul>
</div>
